
// Apple-style: soft tinted background + matching text, no harsh solid fills
const STATUS_STYLES = {
  pending:           "bg-amber-100  text-amber-700  hover:bg-amber-200  border border-amber-200",
  completed:         "bg-green-100  text-green-700  hover:bg-green-200  border border-green-200",
  accept:            "bg-cyan-100   text-cyan-700   hover:bg-cyan-200   border border-cyan-200",
  "delivery pickup": "bg-blue-100   text-blue-700   hover:bg-blue-200   border border-blue-200",
  "out for delivery":"bg-orange-100 text-orange-700 hover:bg-orange-200 border border-orange-200",
  reject:            "bg-red-100    text-red-700    hover:bg-red-200    border border-red-200",
};

// "All" and any unlisted status
const DEFAULT_STYLE = "bg-gray-100 text-gray-600 border border-gray-200 hover:bg-gray-200";

// Active: slightly deeper tint + scale — stays within the same hue
const ACTIVE_STYLE = "brightness-95 scale-105 shadow-md ring-1 ring-inset ring-black/10";

const OrderStatusBlocks = ({
  displayStatuses,
  handleStatusClick,
  selectedSort,
  getCountByStatus,
}) => (
  <div className="hidden md:flex flex-wrap gap-2.5 mb-6">
    {displayStatuses.map((status) => {
      const isActive = selectedSort === status || (status === "all" && !selectedSort);
      const base = STATUS_STYLES[status] || DEFAULT_STYLE;
      return (
        <div
          key={status}
          onClick={() => handleStatusClick(status)}
          className={`h-20 w-36 flex flex-col items-center justify-center text-center text-sm
            font-semibold rounded-xl cursor-pointer whitespace-nowrap flex-none select-none
            transition-all duration-200 shadow-sm
            ${base} ${isActive ? ACTIVE_STYLE : ""}`}
        >
          <span>{status.charAt(0).toUpperCase() + status.slice(1)}</span>
          <span className="text-xs mt-0.5 opacity-75">({getCountByStatus(status)})</span>
        </div>
      );
    })}
  </div>
);

export default OrderStatusBlocks;
